export default [
	{
		path: '/veiculos',
		name: 'vehicles.index',
		component: () => import(/* webpackChunkName: "vehicles.index" */ './pages/Index.vue')
	}
]